@use 'common' as *;

.root :global(.hljs) {
  --hljs-text-default: #24292e;
  --hljs-text-keyword: #d73a49;
  --hljs-text-title: #6f42c1;
  --hljs-text-attribute: #005cc5;
  --hljs-text-string: #032f62;
  --hljs-text-built-in: #e36209;
  --hljs-text-comment: #6a737d;
  --hljs-text-selector: #22863a;
  --hljs-text-subst: #24292e;
  --hljs-text-section: #005cc5;
  --hljs-text-bullet: #735c0f;
  --hljs-text-emphasis: #24292e;
  --hljs-text-strong: #24292e;
  --hljs-bg-addition: #f0fff4;
  --hljs-bg-deletion: #ffeef0;
  --hljs-text-addition: #22863a;
  --hljs-text-deletion: #b31d28;
}

@include dark-mode {
  .root :global(.hljs) {
    --hljs-text-default: #adbac7;
    --hljs-text-keyword: #f47067;
    --hljs-text-title: #dcbdfb;
    --hljs-text-attribute: #6cb6ff;
    --hljs-text-string: #96d0ff;
    --hljs-text-built-in: #f69d50;
    --hljs-text-comment: #768390;
    --hljs-text-selector: #8ddb8c;
    --hljs-text-subst: #adbac7;
    --hljs-text-section: #316dca;
    --hljs-text-bullet: #eac55f;
    --hljs-text-emphasis: #adbac7;
    --hljs-text-strong: #adbac7;
    --hljs-bg-addition: #1b4721;
    --hljs-bg-deletion: #78191b;
    --hljs-text-addition: #b4f1b4;
    --hljs-text-deletion: #ffd8d3;
  }
}

.root {
  :global .hljs {
    display: block;
    overflow-x: auto;
    padding: var(--dixa-size-spacer-200);
    color: var(--hljs-text-default);
    background: transparent;
    -webkit-text-size-adjust: none;

    .hljs-doctag,
    .hljs-keyword,
    .hljs-meta .hljs-keyword,
    .hljs-template-tag,
    .hljs-template-variable,
    .hljs-type,
    .hljs-variable.language_ {
      color: var(--hljs-text-keyword);
    }

    .hljs-title,
    .hljs-title.class_,
    .hljs-title.class_.inherited__,
    .hljs-title.function_ {
      color: var(--hljs-text-title);
    }

    .hljs-attr,
    .hljs-attribute,
    .hljs-literal,
    .hljs-meta,
    .hljs-number,
    .hljs-operator,
    .hljs-variable,
    .hljs-selector-attr,
    .hljs-selector-class,
    .hljs-selector-id {
      color: var(--hljs-text-attribute);
    }

    .hljs-regexp,
    .hljs-string,
    .hljs-meta .hljs-string {
      color: var(--hljs-text-string);
    }

    .hljs-built_in,
    .hljs-symbol {
      color: var(--hljs-text-built-in);
    }

    .hljs-comment,
    .hljs-code,
    .hljs-formula {
      color: var(--hljs-text-comment);
    }

    .hljs-name,
    .hljs-quote,
    .hljs-selector-tag,
    .hljs-selector-pseudo {
      color: var(--hljs-text-selector);
    }

    .hljs-subst {
      color: var(--hljs-text-subst);
    }

    .hljs-section {
      color: var(--hljs-text-section);
      font-weight: bold;
    }

    .hljs-bullet {
      color: var(--hljs-text-bullet);
    }

    .hljs-emphasis {
      color: var(--hljs-text-emphasis);
      font-style: italic;
    }

    .hljs-strong {
      color: var(--hljs-text-strong);
      font-weight: bold;
    }

    .hljs-addition {
      color: var(--hljs-text-addition);
      background-color: var(--hljs-bg-addition);
    }

    .hljs-deletion {
      color: var(--hljs-text-deletion);
      background-color: var(--hljs-bg-deletion);
    }
  }
}
